// The id is stored on operatorBranding.themeId and validated against this set, so
// renaming it is a data migration, not a copy change. U07 is the name rollout only:
// the label is what a human reads, and that is what moved. Do not "finish the job"
// by renaming the id without migrating the stored values first.
export const DEFAULT_THEME_ID = 'invoice-meteor';

export const THEME_OPTIONS = Object.freeze([
  Object.freeze({ id: DEFAULT_THEME_ID, label: 'Meritmark' }),
  Object.freeze({ id: 'mygen-signal', label: 'Mygen Signal' }),
  Object.freeze({ id: 'civic-clean', label: 'Civic Clean' }),
]);

const THEME_IDS = new Set(THEME_OPTIONS.map((theme) => theme.id));

export function normalizeThemeId(value) {
  const themeId = String(value || '');
  return THEME_IDS.has(themeId) ? themeId : DEFAULT_THEME_ID;
}

export function validateThemeId(value) {
  const themeId = String(value || '');
  if (!THEME_IDS.has(themeId)) throw new Error('Unknown operator theme.');
  return themeId;
}
